package com.milta.core.localization.translations.de

import com.milta.core.localization.RouteCreationStrings

internal val RouteCreation = RouteCreationStrings(
    newRouteTitle = "Neue Tour",
    stepDeliveries = "Lieferungen",
    stepDrivers = "Fahrer",
    stepDistribution = "Verteilung",
    deliveriesSummary = "%1 Lieferungen · %2 Pakete",
    deliveriesSummaryOne = "1 Lieferung · %1 Pakete",
    toFixCount = "%1 zu korrigieren",
    allAddressesCorrect = "Alle Adressen sind korrekt",
    filterAll = "Alle %1",
    filterToFix = "Zu korrigieren %1",
    fixAddressesToContinue = "Korrigieren Sie %1 Adressen, um fortzufahren",
    fixOneAddressToContinue = "Korrigieren Sie 1 Adresse, um fortzufahren",
    continueWithDeliveries = "Weiter · %1 Lieferungen",
    continueWithOneDelivery = "Weiter · 1 Lieferung",
    chooseAtLeastOneDriver = "Wählen Sie mindestens einen Fahrer",
    reasonMissingHouseNumber = "Hausnummer fehlt",
    reasonNotFound = "Adresse nicht gefunden",
    reasonUnverified = "Prüfung nicht möglich, bitte erneut versuchen",
    missingHouseNumberExample = "Die Hausnummer fehlt. Beispiel: %1",
    notFoundHelp = "Adresse nicht gefunden. Prüfen Sie Straße, Hausnummer und Postleitzahl.",
    unverifiedHelp = "Die Adresse konnte gerade nicht geprüft werden. Versuchen Sie es gleich noch einmal.",
    addToExistingHint = "Sie werden zu den %1 Lieferungen hinzugefügt, die bereits in der Liste sind.",
    importFileAction = "Datei importieren",
    importFileHint = "Excel (.xlsx, .xls), CSV oder PDF",
    manualEntryAction = "Manuelle Eingabe",
    manualEntryHint = "Name, Adresse, Telefon, Uhrzeit",
    addDeliveryTitle = "Lieferung hinzufügen",
    deleteDelivery = "Lieferung löschen",
    addedFileAnalysing = "Analyse von %1 läuft…",
    addedFileFailed = "Der Import von %1 ist fehlgeschlagen. Es wurde keine Lieferung hinzugefügt.",
    errorAddressesToFix = "Einige Adressen wurden nicht bestätigt: Korrigieren Sie sie in der Liste „Zu korrigieren“.",
    errorAddressesCheckRetry = "Die Prüfung der Adressen ist nicht abgeschlossen. Versuchen Sie es gleich noch einmal.",
    errorBatchAlreadyDispatched = "Diese Verteilung wurde bereits an die Fahrer gesendet.",
    editDeliveryTitle = "Lieferung bearbeiten",
    zoneLabel = "Zone %1",
    workloadBalanced = "Arbeitszeiten zwischen den Fahrern ausgeglichen",
    workloadGap = "Unterschied der Arbeitszeit zwischen den Fahrern: %1",
    importAddedFromScan = "%1 Lieferungen aus dem Scan hinzugefügt",
    importAddedOneFromScan = "1 Lieferung aus dem Scan hinzugefügt",
    importAddedFromPdf = "%1 Lieferungen aus dem PDF hinzugefügt",
    importAddedOneFromPdf = "1 Lieferung aus dem PDF hinzugefügt",
    importAddedFromSpreadsheet = "%1 Lieferungen aus der Excel-Datei hinzugefügt",
    importAddedOneFromSpreadsheet = "1 Lieferung aus der Excel-Datei hinzugefügt",
    importAddedToFixSuffix = ", davon %1 zu korrigieren",
    deliverySearchOpenAction = "Lieferung suchen",
    deliverySearchCount = "%1 von %2",
    deliverySearchCountToFix = "%1 von %2 zu korrigieren",
    deliverySearchEmptyTitle = "Keine passende Lieferung",
    deliverySearchEmptyToFixHint = "Keine zu korrigierende Lieferung passt. Versuchen Sie es unter „Alle“.",
)
